import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="loading">
      <div></div>
    </div>
  );
};

export default Loader;

// import React from 'react'
// import "./Loader.css";
// import img from './searching.gif'

// const Loader = () => {
//     return (
//         <div className='search-loader'><img src={img} alt='searching' /></div>  
//     )
// }

// export default Loader;
